"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierBox = exports.PriceLabel = exports.ButtonRow = exports.PriceButton = exports.List = exports.TierName = exports.ImageWrapper = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _utils_1 = require("@utils");
const _theme_1 = require("@theme");
const _api_1 = __importDefault(require("@api"));
const _store_1 = __importDefault(require("@store")); // Component
var AccountPricing = function AccountPricing() {
    var _React$useState = react_1.default.useState(false), processing = _React$useState[0], setProcessing = _React$useState[1];
    var _useGlobal = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.notification;
    }, function (actions) {
        return actions.setNotification;
    }), setNotification = _useGlobal2[1];
    var _React$useState2 = react_1.default.useState(false), modalVisible = _React$useState2[0], setModalVisible = _React$useState2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.regBundle;
    }, function (actions) {
        return actions.setRegBundle;
    }), regBundle = _useGlobal3[0];
    var _useLocalStorage = _utils_1.useLocalStorage('newUserTier', 'digital'), setTier = _useLocalStorage[1];
    var setTierAndAdvance = function setTierAndAdvance(tier) {
        /*  There are two possible flows:
         *  1. from RegisterInLayout or some other form within the site flow.
         *  2. from within the AccountInHeader forms
         *
         *  If the former, user already filled out name/email (regBundle).
         *  If the latter, user will go from Pricing to name/email form.
         */
        setTier(tier);
        if (regBundle && regBundle.firstName && regBundle.lastName && regBundle.email) {
            setProcessing(true);
            _api_1.default('register', Object.assign({}, regBundle, {
                tier: tier
            })).then(function (response) {
                if (!response)
                    return;
                switch (response.status) {
                    case 201:
                        {
                            // account created; fetch login email
                            _api_1.default('login', {
                                email: regBundle.email
                            }).then(function () {
                                setPanel('checkEmail');
                                setProcessing(false);
                            });
                            break;
                        }
                    default:
                        {
                            response && response.json().then(function (responseObject) {
                                var _responseObject$messa;
                                if (typeof responseObject.message === 'string')
                                    responseObject.message = [responseObject.message];
                                (_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.map(function (message) {
                                    return setNotification({
                                        type: 'warning',
                                        title: 'Registration error',
                                        message: message
                                    });
                                });
                                if (regBundle) {
                                    setPanel('register');
                                }
                                setProcessing(false);
                            });
                        }
                }
            }).catch(function (error) {
                setNotification({
                    type: 'warning',
                    title: 'Registration error',
                    message: error === null || error === void 0 ? void 0 : error.message
                });
                if (regBundle) {
                    setPanel('register');
                    setProcessing(false);
                }
            });
        }
        else {
            setPanel('register');
            setProcessing(false);
        }
    };
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.BackButton, {
        onClick: function onClick() {
            return setPanel('login');
        }
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Arrow, null)), /*#__PURE__*/ react_1.default.createElement(Columns, null, AccountInHeader_1.tiers.map(function (tier) {
        return /*#__PURE__*/ react_1.default.createElement(Column, {
            key: tier.name
        }, /*#__PURE__*/ react_1.default.createElement(exports.ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, {
            src: "/images/accounts/" + tier.name + "Header.png",
            objectFit: "cover"
        })), /*#__PURE__*/ react_1.default.createElement(exports.TierName, null, _utils_1.capitalize(tier.name)), /*#__PURE__*/ react_1.default.createElement(exports.List, null, tier.features.map(function (feature, i) {
            return /*#__PURE__*/ react_1.default.createElement("li", {
                key: i,
                dangerouslySetInnerHTML: {
                    __html: feature
                }
            });
        })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.TriggerWrapper, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Trigger, {
            onClick: function onClick() {
                return setModalVisible(true);
            }
        }, tier.name == 'digital' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, "Compare Tiers"), tier.name !== 'digital' && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, "See The Full List"))), /*#__PURE__*/ react_1.default.createElement(exports.PriceButton, {
            type: "outline",
            display: "flex",
            onClick: function onClick() {
                return setTierAndAdvance(tier.name);
            },
            disabled: processing
        }, /*#__PURE__*/ react_1.default.createElement(exports.ButtonRow, null, /*#__PURE__*/ react_1.default.createElement(exports.PriceLabel, {
            className: tier.priceInCents ? 'cash' : ''
        }, tier.priceInCents ? _utils_1.money(tier.priceInCents) : 'Free'))));
    })), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Footer, null, /*#__PURE__*/ react_1.default.createElement("li", null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Trigger, {
        onClick: function onClick() {
            return setModalVisible(true);
        }
    }, "Compare Tiers"))), /*#__PURE__*/ react_1.default.createElement(atoms_1.Modal, {
        visible: modalVisible,
        setVisible: setModalVisible
    }, /*#__PURE__*/ react_1.default.createElement(molecules_1.TierComparison, null)));
}; // Columns
var Columns = styled_components_1.default.div.withConfig({
    displayName: "AccountPricing__Columns",
    componentId: "sc-1rknc7t-0"
})(["", "{width:100%;display:flex;justify-content:space-between;}"], _utils_1.mediaQuery('tablet'));
var Column = styled_components_1.default.div.withConfig({
    displayName: "AccountPricing__Column",
    componentId: "sc-1rknc7t-1"
})(["position:relative;margin-bottom:64px;&:first-of-type{& li:first-of-type{color:", ";&::before{border-color:", ";}}}&:nth-of-type(2){&::after{position:absolute;top:-11px;right:-16px;display:flex;justify-content:center;align-items:center;background-color:", ";width:auto;height:24px;padding:0 16px;border:1px solid ", ";box-shadow:0px 4px 8px ", ";transform:rotate(22deg);color:", ";content:'Popular';", ";}}&:last-of-type{margin-bottom:0;}", "{display:flex;flex-direction:column;justify-content:space-between;align-items:stretch;width:calc(33.33% - 20px);margin-bottom:0;&:nth-of-type(2){&::after{top:-12px;right:-16px;}}}", "{&:nth-of-type(2){&::after{top:-16px;right:-19px;height:32px;padding:0 24px;}}}"], _theme_1.palette.ink, _theme_1.palette.ink, _theme_1.palette.white, _utils_1.rgba(_theme_1.palette.ink, 0.64), _utils_1.rgba(_theme_1.palette.black, 0.1), _theme_1.palette.ink, _theme_1.type.labelSmall, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop')); // Tiers
exports.ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "AccountPricing__ImageWrapper",
    componentId: "sc-1rknc7t-2"
})(["position:relative;height:160px;margin-bottom:32px;overflow:hidden;", "{height:120px;margin-bottom:40px;}", "{height:160px;}", "{height:180px;margin-bottom:48px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.TierName = styled_components_1.default.h2.withConfig({
    displayName: "AccountPricing__TierName",
    componentId: "sc-1rknc7t-3"
})(["margin-bottom:40px;", " text-align:center;color:", ";&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.1) * 1em);}&::after{margin-bottom:calc((1 - 1.4) * 1em);}", "{margin-bottom:48px;}", "{margin-bottom:56px;}", "{margin-bottom:64px;}"], _theme_1.type.h2, _theme_1.palette.black, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.List = styled_components_1.default.ul.withConfig({
    displayName: "AccountPricing__List",
    componentId: "sc-1rknc7t-4"
})(["padding-left:8px;margin-bottom:32px;", " & li{position:relative;padding-left:26px;margin-bottom:12px;&:first-of-type{color:", ";&:before{border-color:", ";}}&:last-of-type{margin-bottom:0;}&::before{position:absolute;left:2px;top:3px;width:5px;height:10px;border:solid ", ";border-width:0 2px 2px 0;transform:rotate(45deg);content:'';}}", "{min-height:164px;}", "{margin-bottom:40px;& li{padding-left:28px;margin-bottom:16px;&::before{width:6px;height:12px;}}}", "{min-height:184px;margin-bottom:48px;padding-left:24px;& li{padding-left:32px;&::before{top:4px;}}}"], _theme_1.type.pLargeSans, _theme_1.palette.brown, _theme_1.palette.brown, _theme_1.palette.ink, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // "row button"
// TODO: turn this into a "type" of <Button /> if we wind up using this elsewhere
exports.PriceButton = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, props);
}).withConfig({
    displayName: "AccountPricing__PriceButton",
    componentId: "sc-1rknc7t-5"
})(["position:relative;background-color:", ";height:56px;border-color:", ";color:", ";&::after{position:absolute;top:0;left:0;width:100%;height:100%;box-shadow:0px 12px 18px ", ";content:'';opacity:0.2;transition:opacity 0.25s ease-in-out;pointer-events:none;}& > button{padding:0 16px;}", "{&:hover{background-color:", ";border-color:", ";color:", ";&::after{opacity:1;}}}", "{height:64px;& > button{padding:0 24px;}}", "{height:72px;& > button{padding:0 32px;}}"], _theme_1.palette.white, _utils_1.rgba(_theme_1.palette.ink, 0.64), _theme_1.palette.ink, _utils_1.rgba(_theme_1.palette.black, 0.16), _utils_1.mediaQuery('tablet'), _utils_1.rgba(_theme_1.palette.brown, 0.8), _utils_1.rgba(_theme_1.palette.brown, 0.8), _theme_1.palette.white, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.ButtonRow = styled_components_1.default.div.withConfig({
    displayName: "AccountPricing__ButtonRow",
    componentId: "sc-1rknc7t-6"
})(["display:flex;flex-direction:row;justify-content:center;transition:color 0.25s ease-in-out;", "{", ":hover &{color:", ";}}"], _utils_1.mediaQuery('tablet'), exports.PriceButton, _theme_1.palette.snow);
exports.PriceLabel = styled_components_1.default.div.withConfig({
    displayName: "AccountPricing__PriceLabel",
    componentId: "sc-1rknc7t-7"
})(["", " text-transform:capitalize;color:", ";text-shadow:1px 1px 0 ", ";transition:color       0.25s ease-in-out,text-shadow 0.25s ease-in-out;&.cash&::before{display:inline;margin-right:2px;content:'$';vertical-align:0.3em;font-size:1.2rem;font-weight:500;}&.cash&::after{display:inline;margin-left:2px;content:'/YR';vertical-align:0;font-size:1.0rem;font-weight:500;}", "{", ":hover &{color:", ";text-shadow:1px 1px 1px ", ";}}", "{&.cash&::before{margin-right:3px;font-size:1.4rem;}&.cash&::after{margin-left:3px;}}", "{&.cash&::before{margin-right:4px;vertical-align:0.45em;}&.cash&::after{margin-left:4px;}}"], _theme_1.type.labelXLarge, _theme_1.palette.ink, _utils_1.rgba(_theme_1.palette.brown, 0), _utils_1.mediaQuery('tablet'), exports.PriceButton, _theme_1.palette.snow, _utils_1.rgba(_theme_1.palette.brown, 0.8), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.TierBox = styled_components_1.default.div.withConfig({
    displayName: "AccountPricing__TierBox",
    componentId: "sc-1rknc7t-8"
})(["padding:40px 0;border-top:1px solid ", ";border-bottom:1px solid ", ";", "{padding:48px 0;border:1px solid ", ";}", "{padding:56px 0;}", "{padding:64px 0;}"], _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.mediaQuery('tablet'), _utils_1.rgba(_theme_1.palette.ink, 0.32), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.default = AccountPricing;
